import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import PromptForm from './PropmtForm'
import Box from '@material-ui/core/Box';
import LoadingScreen from './LoadingScreen';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const ImgPresent = (QRPay) => <img src={`${QRPay}`} alt='some value'/>

class DialogOTP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      value: 0,
    }
  }

  handleChange = (event, newValue) => {
    this.setState({type: newValue});
  };
  handleChangeOTP = (event) => {
    this.setState({value: event.target.value});
  };
  handleSubmit(data) {
    // console.log(data)
    // handleOTPSubmit(data.dataForm.data)
  }

  render() {
    const { onCloseDialogOTP, openDialogOTP,
            QRPay, initialTime, OTPSubmit, showQR, loading, handleChangeInputOtp, onKeyPress} = this.props;
    const { type } = this.state;

    //console.log(onKeyPress)

    return (
      <React.Fragment>
       
              <Dialog
                  open={ openDialogOTP }
                  onClose={ onCloseDialogOTP }
                  fullWidth={true}
                  maxWidth= 'xs'
                  disableBackdropClick
                  disableEscapeKeyDown
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
              >
                  <DialogContent style = {{backgroundColor: "#0097a0"}}>
                      <DialogContentText id="alert-dialog-description" align="center" style = {{fontSize: "1rem", color: "#fffffe", fontWeight: 'bold'}}>
                        {'Ingrese el código de verificación enviado a su celular.' }
                      </DialogContentText>
                      <div>

                        {/* <DialogContentText id="alert-dialog-description-time" align="center">
                          <Countdown date={initialTime + 300000}  onComplete = { onCloseDialogOTP }/>
                        </DialogContentText> */}

                        <PromptForm
                                {...this.state}
                                label = {'Digite su Código'}
                                onSubmit = {OTPSubmit}
                                dataForm = { {} }
                                cancelPrompt = {onCloseDialogOTP}
                                initialTime = {initialTime}
                                handleChangeInputOtp = {handleChangeInputOtp}
                                onKeyPress = {onKeyPress}
                                loading = { loading }
                        />
                                

                      </div>

                        {/* <Tabs
                          value={type}
                          onChange={this.handleChange}
                          variant="fullWidth"
                          scrollButtons="off"
                          indicatorColor="primary"
                          textColor="primary"
                        >
                        <Tab label="OTP" icon={<CodeIcon />} {...a11yProps(0)} />
                          {showQR &&<Tab label="QR" icon={<CropFreeIcon />} {...a11yProps(1)} />}
                        </Tabs> */}

                          
                        <TabPanel value={type} index={0}>
                        </TabPanel>
                        { showQR && <TabPanel value={type} index={1}>
                          <Grid container spacing={1}>
                            <Grid container item xs={12} spacing={1}>
                              <React.Fragment>
                                <CssBaseline />
                                <Container maxWidth="md">
                                  <Typography component="div" align="center" >
                                      {ImgPresent('data:image/png;base64,'+QRPay)}
                                  </Typography>
                                </Container>
                              </React.Fragment>
                              </Grid>
                              <Grid container item xs={4} spacing={1}>
                              </Grid>
                              <Grid container item xs={5} spacing={2}>
                              <Button variant="contained" onClick = { onCloseDialogOTP }>
                                  Cancelar
                              </Button>
                              </Grid>
                            </Grid>
                        </TabPanel> }
                    </DialogContent>
                    <LoadingScreen open = {loading} />
                  
            </Dialog>
            
          </React.Fragment>
    )
  }
}

DialogOTP.propTypes = {
    // PayType: PropTypes.func.isRequired,
    onCloseDialogOTP: PropTypes.func.isRequired,
    openDialogOTP: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    // onAcceptClick: PropTypes.func.isRequired,
}

export default DialogOTP